import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, forkJoin, map, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { UserProfileService } from './user-profile.service';
import { da } from 'date-fns/locale';
import { ICommentTribe, IcommentResponse } from '../shared/interfaces/comment-tribe.interface';
import { ITribesResponse, ICommentTribesTranformed } from '../shared/interfaces/tribe.interface';
import { ICreateCommentResponse } from '../shared/interfaces/create-comment-tribe-response.interface';

const HOST = environment.host;
const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class CommentsTribeService {
  constructor(
    private http: HttpClient,
    private userProfileService: UserProfileService
  ) {}

    getResultCommentCreated$ = new Subject<ICreateCommentResponse>();

  // @Deprecated
  // getCommentsByIdTribeOld(idTribe: string):Observable<ICommentTribe[]> {
  //   return this.http
  //     .get(
  //       `${HOST}/api/comment/comment_forum?sort=-created&filter[entity_id.id][value]=${idTribe}`
  //     )
  //     .pipe(
  //       map(({ data }: any) => {
  //         console.log('data:', data);
  //         const newData = data.map((element: any) => {
  //           return {
  //             id_tribe: idTribe,
  //             id_comment: element.id,
  //             field_name: element.attributes.field_name,
  //             status: element.attributes.status,
  //             subject: element.attributes.subject,
  //             thread: element.attributes.thread,
  //             thread_array: element.attributes.thread
  //               .replaceAll('/', '')
  //               .split('.'),
  //             comment_body_value: element.attributes.comment_body.value,
  //             user_uid: element.relationships.uid.data.id,
  //           };
  //         });
  //         return newData;
  //       })
  //     );
  // }

  getCommentsByIdTribe(idTribe: number):Observable<ICommentTribe[]> {
    return this.http.get(`${HOST}/api/comments_forum/${idTribe}`).pipe(
      map((data: any) => {
        // console.log('data comment by id:', data);
        const newData:ICommentTribe[] = data.map((element: IcommentResponse) => {
          return {
            id_tribe: element.entity_id[0].target_id,
            uuid_tribe: element.entity_id[0].target_uuid,
            id_comment: element.uuid[0].value,
            target_uuid: element.entity_id[0].target_uuid,
            // field_name:element.attributes.field_name,
            status: element.status[0].value,
            subject: element.subject[0].value,
            user_uid: element.uid[0].target_uuid,
            // entity_id:element.entity_id[0].target_id,
            created: element.created[0].value,
            changed: element.changed[0].value,
            thread: element.thread[0].value,
            thread_array: element.thread[0].value
              .replaceAll('/', '')
              .split('.'),
            comment_body_value: element.comment_body[0].value,
          };
        });
        return newData;
      })
    );
  }

  getCommentsWithUserByIdTribe(idTribe: string) {
    return this.http
      .get(
        `${HOST}/api/comment/comment_forum?sort=-created&filter[entity_id.id][value]=${idTribe}`
      )
      .pipe(
        switchMap(({ data }: any) => {
          console.log('data:', data);
          const $usersData: any = [];
          const newData = data.map((element: any) => {
            $usersData.push(
              this.userProfileService.getUserProfileCompleteById(
                element.relationships.uid.data.id
              )
            );
            return {
              id_tribe: idTribe,
              id_comment: element.id,
              field_name: element.attributes.field_name,
              status: element.attributes.status,
              subject: element.attributes.subject,
              thread: element.attributes.thread,
              thread_array: element.attributes.thread
                .replaceAll('/', '')
                .split('.'),
              comment_body_value: element.attributes.comment_body.value,
              user_uid: element.relationships.uid.data.id,
            };
          });
          return forkJoin($usersData).pipe(
            map((usersData: any) => {
              console.log('usersData:', usersData);
              newData.forEach((element: any, index: number) => {
                element.user_profile = usersData[index];
              });
              return newData;
            })
          );
        })
      );
  }

  createCommentTribe(
    uuidTribe: string,
    subjectComment: string,
    toThread: string | null
  ):Observable<{data:ICreateCommentResponse}> {
    ///get user data from localstorage
    // console.log("createCommentTribe",uuidTribe,subjectComment,toThread)
    const user = JSON.parse(
      localStorage.getItem('profile_current_user') || '{}'
    );
    const userUuid = user.id;
    const threadClean = toThread?.replaceAll("/", "");
    const uuidThreadGenerator = `aazl${Date.now()}`
    const newThread = threadClean+"."+uuidThreadGenerator+"/";

    const headers = new HttpHeaders()
      .set('Accept', 'application/vnd.api+json')
      .set('Content-Type', 'application/vnd.api+json');

    const data: any = {
      type: 'comment--comment_forum',
      attributes: {
        entity_type: 'node',
        entity_bundle: 'forum',
        field_name: 'comment_forum',
        subject: 'new coment',
        // thread: `${toThread}.and-${Date.now()}-edutegia/`,
        thread: newThread,
        comment_body: [
          { value: `<p>${subjectComment}</p>`, format: 'basic_html' },
        ],
      },
      relationships: {
        uid: {
          data: {
            type: 'user--user',
            id: userUuid, //userUuid,
          },
        },
        entity_id: {
          data: {
            type: 'node--forum',
            id: uuidTribe, ///idTribe,
          },
        },
      },
    };
    if (toThread === null) {
      delete data.attributes.thread;
    }
    // console.log('userUuid:', userUuid);
    // console.log('data:', data);
    // console.log('Headers:', headers);
    return this.http.post<
      {data:ICreateCommentResponse}
    >(
      `${HOST}/api/comment/comment_forum`,
      { data },
      {
        headers: headers,
      }
    );
  }
}

// switchMap(({ data }: any) => {
//   return this.getContentService
//     .getFileContent(data.relationships.user_picture.data.id)
//     .pipe(
